import adminTable from "@store/adminTable/reducers";

import { exams_category } from "@Modules/Exams/configs/constants";

export default adminTable(exams_category);
